import { createTheme } from "@mui/material/styles";

const getTheme = (mode, direction = "ltr") =>
  createTheme({
    palette: {
      mode, // 'light' or 'dark'
      custom: {
        headOpeningBalance: mode === "dark" ? "#4a4a1f" : "lightyellow",
        headMovementBalance: mode === "dark" ? "#444" : "lightgray",
        headEndBalance: mode === "dark" ? "#3c6e3c" : "#90ee90",
        contrastText: mode === "dark" ? "#fff" : "#000",
      },
    },
    direction, // 'rtl' or 'ltr'
    typography: {
      fontFamily:
        direction === "rtl" ? "Cairo, sans-serif" : "Roboto, sans-serif",
    },
  });

export default getTheme;
